<link href="/css/reset.min.css" rel="stylesheet" type="text/css" media="all" />

<div class="bg-wrap">

  <browser-modal></browser-modal>

  <div class="container nopadding">
    <nav class="navbar navbar-default">
      <div class="container-fluid">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#menu-top" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <div class="navbar-brand"><a href=""><img src="/images/logo-main.png" /></a></div>
        </div>

        <div class="collapse navbar-collapse" id="menu-top">
          <ul class="nav navbar-nav navbar-right">
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <div class="body-outer">
    <div class="container">
      <router-outlet></router-outlet>
      <div class="clear"></div>
    </div>
  </div>

  <div class="clear"></div>
</div>
